import type { RateOverride } from '../../../types/economics';
import type { MatterCollaborator } from '../../../hooks/useMatterCollaborators';

/**
 * Is this matter person the one this rate override is for?
 *
 * Overrides carry the numeric `user_id` (+ an enriched `user_uuid`); matter
 * people from the details payload usually carry only the uuid. Matching on the
 * numeric id alone missed, which listed an overridden lawyer under "On their
 * standard rate" too and emptied the locked option when editing an override.
 */
export const isOverrideFor = (
  person: Pick<MatterCollaborator, 'user_id' | 'user_uuid'>,
  override: Pick<RateOverride, 'user_id' | 'user_uuid'>,
): boolean =>
  (!!person.user_id && String(person.user_id) === String(override.user_id)) ||
  (!!person.user_uuid && !!override.user_uuid && person.user_uuid === override.user_uuid);
